import { Pipe, PipeTransform } from '@angular/core';
import {DashboardService} from "../../includes/dashboard/dashboard.service";
import {AuthService} from "../../services/auth.service";

@Pipe({
    name: 'minTime'
})export class MinTimePipe implements PipeTransform {
    currentUser: any;
    title = '';
    constructor(private dashboardService: DashboardService,
                private authService: AuthService) {
        this.currentUser = this.authService.currentUser;
    }
    async transform(element) {

        if (element.start_time) {
            return  element.start_time;
        } else {
            return '12:00 AM';
        }
    }
}
